import { zodResolver } from "@hookform/resolvers/zod";
import { t, Trans } from "@lingui/macro";
import { defaultProfile, profileSchema } from "@reactive-resume/schema";
import {
  Avatar,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Button,
} from "@reactive-resume/ui";
import { useForm } from "react-hook-form";
import type { z } from "zod";

import { BrandIcon } from "@/client/components/brand-icon";

import { SectionDialog } from "../sections/shared/section-dialog";
import { URLInput } from "../sections/shared/url-input";
import { useEffect, useState } from "react";
import { cn } from "@reactive-resume/utils";

const formSchema = profileSchema;

type FormValues = z.infer<typeof formSchema>;

export const ProfilesDialog = () => {
  const form = useForm<FormValues>({
    defaultValues: defaultProfile,
    resolver: zodResolver(formSchema),
  });

  const [selectedIcon, setSelectedIcon] = useState("Linkedin");

  useEffect(() => {
    form.setValue("network", selectedIcon);
    form.setValue("icon", selectedIcon);
  }, [selectedIcon]);

  return (
    <SectionDialog<FormValues> id="profiles" form={form} defaultValues={defaultProfile}>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {/* <FormField
          name="network"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t`Network`}</FormLabel>
              <FormControl>
                <Input {...field} placeholder="GitHub" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        /> */}

        <FormField
          name="username"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t`Username`}</FormLabel>
              <FormControl>
                <Input {...field} placeholder="john.doe" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          name="url"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormLabel>Lien URL</FormLabel>
              <FormControl>
                <URLInput {...field} placeholder="https://github.com/johndoe" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          name="network"
          control={form.control}
          render={({ field }) => (
            <FormItem className="sm:col-span-2">
              <FormLabel htmlFor="iconSlug">{t`Network`}</FormLabel>
              {/* field.value ="linkedin";field.onChange()  */}
              <FormControl>
                <div className="flex items-center gap-x-2">
                  <Button
                    type="button"
                    className={cn(
                      "size-16 rounded-full bg-transparent",
                      selectedIcon === "github" ? "rounded-full border border-focus-success" : "",
                    )}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedIcon("github");
                    }}
                  >
                    <Avatar className="hover:border-brand size-8 bg-white p-1.5">
                      <BrandIcon slug={"github"} />
                    </Avatar>
                  </Button>
                  <Button
                    type="button"
                    className={cn(
                      "size-16 rounded-full bg-transparent",
                      selectedIcon === "facebook" ? "rounded-full border border-focus-success" : "",
                    )}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedIcon("facebook");
                    }}
                  >
                    <Avatar className="hover:border-brand size-8 bg-white p-1.5">
                      <BrandIcon slug={"facebook"} />
                    </Avatar>
                  </Button>
                  <Button
                    type="button"
                    className={cn(
                      "size-16 rounded-full bg-transparent",
                      selectedIcon === "instagram"
                        ? "rounded-full border border-focus-success"
                        : "",
                    )}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedIcon("instagram");
                    }}
                  >
                    <Avatar className="hover:border-brand size-8 bg-white p-1.5">
                      <BrandIcon slug={"instagram"} />
                    </Avatar>
                  </Button>
                  <Button
                    type="button"
                    className={cn(
                      "size-16 rounded-full bg-transparent",
                      selectedIcon === "linkedin" ? "rounded-full border border-focus-success" : "",
                    )}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedIcon("linkedin");
                    }}
                  >
                    <Avatar className="hover:border-brand size-8 bg-white p-1.5">
                      <BrandIcon slug={"linkedin"} />
                    </Avatar>
                  </Button>
                  <Button
                    type="button"
                    className={cn(
                      "size-16 rounded-full bg-transparent",
                      selectedIcon === "x" ? "rounded-full border border-focus-success" : "",
                    )}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedIcon("x");
                    }}
                  >
                    <Avatar className="hover:border-brand size-8 bg-white p-1.5">
                      <BrandIcon slug={"x"} />
                    </Avatar>
                  </Button>
                  {/* <Input {...field} placeholder="github" onChange={} /> */}
                </div>
              </FormControl>
              <FormMessage />
              {/* <FormDescription className="ml-10">
                <Trans>
                  Powered by{" "}
                  <a
                    href="https://simpleicons.org/"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="font-medium"
                  >
                    Simple Icons
                  </a>
                </Trans>
              </FormDescription> */}
            </FormItem>
          )}
        />
      </div>
    </SectionDialog>
  );
};
